import { useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import s from "../clinic.module.css";

export default function AdminDoctorAudit({ doctorId }) {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    clinicAPI.getDoctorAudit(doctorId).then((r) => setLogs(r.audit || []));
  }, [doctorId]);

  return (
    <ul className={s.auditList}>
      {logs.length === 0 ? (
        <li className={s.attachmentHint}>Нет записей</li>
      ) : (
        logs.map((log) => (
          <li key={log.id} className={s.auditItem}>
            <div className={s.auditAction}>{log.action}</div>
            <div className={s.auditMeta}>
              {new Date(log.createdAt).toLocaleString("ru-RU")} ·{" "}
              {log.actor?.full_name || log.actor?.email || "Система"}
            </div>
          </li>
        ))
      )}
    </ul>
  );
}
